import { type FC } from 'react';
import { Button } from 'react-bootstrap';

import ButtonTooltip from '@editor2/components/ButtonTooltip';

interface Props {
	name: string;
	tooltip: string;
	variant: string;
	onAcceptClick: () => void;
}

const AcceptButton: FC<Props> = ({ name, tooltip, variant, onAcceptClick }) => {
	return (
		<ButtonTooltip message={tooltip}>
			<Button variant={variant} onClick={onAcceptClick} size="sm" className="acceptButton">
				{name}
			</Button>
		</ButtonTooltip>
	);
};

export default AcceptButton;
